import { DataTable } from 'components/data/DataTable/DataTable';
import { supplierColumns } from 'data-structures/sharedColumns/supplierColumns';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllSuppliers } from 'store/services/suppliers';
import { Supplier } from 'types';
import styles from './Suppliers.module.scss';

export const Suppliers = () => {
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [didAddSupplier, setDidAddSupplier] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAllSuppliers().then((data) => {
            setIsLoading(false);
            if (data) return setSuppliers(data);
            return setSuppliers([]);
        });
    }, []);

    // After a new supplier has been added, query for the latest supplier list data.
    useEffect(() => {
        if (didAddSupplier) {
            setIsLoading(true);
            setTimeout(() => {
                getAllSuppliers().then((data) => {
                    if (data) setSuppliers(data);
                    setIsLoading(false);
                    setDidAddSupplier(false);
                });
            }, 1000);
        }
    }, [didAddSupplier]);

    const navigate = useNavigate();

    return (
        <div data-testid="SuppliersPage" className={styles.container}>
            <DataTable
                id="supplier"
                data={suppliers}
                columns={supplierColumns}
                loading={isLoading}
                onRowClick={(params) =>
                    navigate(
                        `/supplier-details/${params.row.supplierId}/accounts`,
                        {
                            state: params?.row,
                        }
                    )
                }
                getRowId={(supplier) => supplier.supplierId}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'deviceCount', sort: 'desc' }],
                    },
                }}
                dataFormatter={(data) => {
                    return data;
                }}
                getRowCount={(data) => data?.length ?? 0}
                csvOptions={{
                    fileName: 'suppliers-list',
                }}
            />
        </div>
    );
};
